<script>
import { Bar } from 'vue-chartjs'
import Tools from '@/tools/tools.js'

const fmtBRL = v => Number(v || 0).toLocaleString('pt-BR', { style:'currency', currency:'BRL' })

export default {
  extends: Bar,
  name: 'GraficoComissoesVendedores',
  props: {
    vendedores: { type: Array, default: () => [] },
    rotateLabels: { type: Boolean, default: true }
  },
  data () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return 'Comissão: ' + fmtBRL(tooltipItem.yLabel);
            }
          }
        },
        scales: {
          xAxes: [{
            gridLines: { display: false },
            ticks: {
              autoSkip: false,
              callback: v => {
                const s = String(v || '')
                return s.length > 15 ? s.slice(0, 15) + '…' : s
              }
            }
          }],
          yAxes: [{ 
            gridLines: { display: true }, 
            ticks: { 
              beginAtZero: true, 
              callback: v => fmtBRL(v) 
            } 
          }]
        }
      }
    }
  },
  methods: {
    getCor(idx) {
      const colors = [
        'hsla(210, 70%, 50%, 0.6)', // Blue
        'hsla(160, 70%, 45%, 0.6)', // Teal
        'hsla(30, 70%, 50%, 0.6)',  // Orange
        'hsla(280, 70%, 60%, 0.6)', // Purple
        'hsla(340, 70%, 50%, 0.6)', // Pink
        'hsla(200, 70%, 45%, 0.6)', // Cyan
        'hsla(50, 70%, 50%, 0.6)',  // Yellow
        'hsla(120, 70%, 40%, 0.6)', // Green
        'hsla(0, 70%, 50%, 0.6)'    // Red
      ]
      return colors[idx % colors.length]
    },
    getBorderCor(idx) {
      const colors = [
        'hsl(210, 70%, 40%)',
        'hsl(160, 70%, 35%)',
        'hsl(30, 70%, 40%)',
        'hsl(280, 70%, 50%)',
        'hsl(340, 70%, 40%)',
        'hsl(200, 70%, 35%)',
        'hsl(50, 70%, 40%)',
        'hsl(120, 70%, 30%)',
        'hsl(0, 70%, 40%)'
      ]
      return colors[idx % colors.length]
    },
    renderGrafico () {
      if (!this.vendedores || this.vendedores.length === 0) return;

      // Ordenar por comissão decrescente
      const ordenados = [...this.vendedores].sort((a, b) => b.valorComissao - a.valorComissao);
      
      const labels = ordenados.map(v => v.nome);
      const valores = ordenados.map(v => v.valorComissao);
      const ids = ordenados.map(v => v.id);

      const dataset = {
        type: 'bar',
        label: 'Comissão',
        backgroundColor: ordenados.map((_, i) => this.getCor(i)),
        borderColor: ordenados.map((_, i) => this.getBorderCor(i)),
        borderWidth: 2,
        borderRadius: 5,
        data: valores
      }

      const options = {
        ...this.chartOptions,
        scales: {
          ...this.chartOptions.scales,
          xAxes: [{
            ...this.chartOptions.scales.xAxes[0],
            ticks: {
              ...this.chartOptions.scales.xAxes[0].ticks,
              maxRotation: this.rotateLabels ? 45 : 0,
              minRotation: this.rotateLabels ? 45 : 0
            }
          }]
        },
        onClick: (evt) => {
          if (!this._chart) return
          let elems = []
          if (typeof this._chart.getElementsAtEventForMode === 'function') {
            elems = this._chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true, axis: 'x' }, false)
          } else {
            elems = this._chart.getElementAtEvent(evt) || []
          }
          if (elems && elems.length) {
            const el  = elems[0]
            const idx = el._index
            this.$emit('abrir-detalhes-comissao', {
              vendedorId: ids[idx],
              nome: labels[idx],
              totalComissao: valores[idx]
            })
          }
        },
        onHover: (evt, active) => {
          const el = evt?.target
          if (el && el.style) el.style.cursor = active && active.length ? 'pointer' : 'default'
        }
      }

      const data = { labels, datasets: [dataset] }
      
      if (this._chart) this._chart.destroy()
      this.$nextTick(() => this.renderChart(data, options))
    }
  },
  watch: {
    vendedores: {
      handler: 'renderGrafico',
      deep: true
    }
  },
  mounted () {
    this.renderGrafico()
  },
  beforeDestroy () {
    if (this._chart) this._chart.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/GraficoComissoesVendedores.vue